import React from 'react';

const CopyIconGroup = ({ size, fillColor }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      id='b'
      data-name='Capa 2'
      viewBox='0 0 29.67 37.57'
      width={size}
      height={size}
      fill={fillColor}
    >
      <g id='c' data-name='Capa 1'>
        <g>
          <path
            d='M29.67,8.12s0-.04,0-.05c0-.02,0-.04,0-.07,0-.03,0-.05-.01-.07,0-.02,0-.03,0-.05,0-.03-.01-.06-.02-.09,0-.01,0-.02,0-.03,0-.03-.02-.06-.03-.09,0,0,0-.02-.01-.03-.01-.03-.02-.05-.04-.08,0-.01,0-.02-.01-.03-.01-.02-.03-.05-.04-.07,0-.01-.01-.02-.02-.03-.01-.02-.03-.04-.05-.06,0-.01-.02-.02-.03-.04-.02-.02-.04-.04-.06-.06,0,0-.02-.02-.02-.03h0s0,0,0,0L22.44.37s-.06-.06-.09-.08c0,0-.01,0-.02-.01-.03-.02-.05-.04-.08-.06,0,0-.01,0-.02-.01-.03-.02-.06-.04-.09-.05,0,0,0,0-.01,0-.03-.02-.06-.03-.1-.05,0,0,0,0,0,0-.04-.01-.07-.03-.11-.04,0,0,0,0-.01,0-.04-.01-.07-.02-.11-.03,0,0-.02,0-.03,0-.03,0-.06-.01-.09-.01-.04,0-.08,0-.13,0h-12.47c-2.01,0-3.64,1.64-3.64,3.65v1.78h-1.78c-2.01,0-3.65,1.64-3.65,3.65v24.85c0,2.01,1.64,3.64,3.65,3.64h16.95c2.01,0,3.64-1.64,3.64-3.64v-1.78h1.78c2.01,0,3.65-1.64,3.65-3.65V8.13s0,0,0,0c0,0,0,0,0,0ZM22.81,4.31l2.57,2.57h-2.11s0,.01,0,.01c-.16,0-.27-.08-.32-.13-.05-.05-.14-.16-.14-.33v-2.13ZM21.72,33.93c0,.62-.5,1.12-1.12,1.12H3.65c-.62,0-1.12-.5-1.12-1.12V9.07c0-.62.5-1.12,1.12-1.12h11.21v3.92c0,.8.31,1.55.88,2.12.56.56,1.31.87,2.1.87h.02l3.86-.02v19.1ZM19.95,12.32h-2.11c-.17,0-.28-.07-.33-.12-.05-.05-.14-.16-.14-.33v-2.13l2.57,2.57ZM26.03,29.62h-1.78V13.56s0,0,0,0c0,0,0,0,0,0,0-.02,0-.04,0-.06,0-.02,0-.04,0-.07,0-.03,0-.05-.01-.08,0-.01,0-.03,0-.04,0-.03-.01-.06-.02-.09,0-.01,0-.02,0-.03,0-.03-.02-.06-.03-.09,0,0,0-.02,0-.03-.01-.03-.03-.06-.04-.09,0,0,0-.02-.01-.03-.01-.03-.03-.05-.05-.08,0,0-.01-.02-.02-.03-.02-.02-.03-.05-.05-.07,0,0-.01-.02-.02-.03-.02-.02-.04-.05-.06-.07,0,0-.01-.01-.02-.02h0s0,0,0,0l-6.86-6.86s-.06-.06-.09-.08c0,0-.01,0-.02-.01-.03-.02-.05-.04-.08-.06,0,0-.01,0-.02-.01-.03-.02-.06-.04-.09-.05,0,0,0,0-.01,0-.03-.02-.06-.03-.1-.05,0,0,0,0,0,0-.04-.01-.07-.03-.11-.04,0,0,0,0-.01,0-.04-.01-.07-.02-.11-.03,0,0-.02,0-.03,0-.03,0-.06-.01-.09-.01-.04,0-.08,0-.13,0H7.96v-1.78c0-.62.5-1.12,1.12-1.12h11.21v3.92c0,.8.31,1.55.88,2.12.56.56,1.31.87,2.1.87h.02l3.86-.02v19.1c0,.62-.5,1.12-1.12,1.12Z'
            fill='#fff'
          />
          <path
            d='M17.66,16.5H6.59c-.7,0-1.26.57-1.26,1.26s.57,1.26,1.26,1.26h11.07c.7,0,1.26-.57,1.26-1.26s-.57-1.26-1.26-1.26Z'
            fill='#fff'
          />
          <path
            d='M17.66,21.83H6.59c-.7,0-1.26.57-1.26,1.26s.57,1.26,1.26,1.26h11.07c.7,0,1.26-.57,1.26-1.26s-.57-1.26-1.26-1.26Z'
            fill='#fff'
          />
          <path
            d='M17.66,27.15H6.59c-.7,0-1.26.57-1.26,1.26s.57,1.26,1.26,1.26h11.07c.7,0,1.26-.57,1.26-1.26s-.57-1.26-1.26-1.26Z'
            fill='#fff'
          />
        </g>
      </g>
    </svg>
  );
};

export default CopyIconGroup;
